import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-paragraph',
    templateUrl: './block-paragraph.component.html',
})

export class BlockParagraphComponent extends BlockAbstractComponent implements OnInit {

}
